import { colorsPalettes, mixins } from "@similarweb/styles";
import styled from "styled-components";

export const StyledExportInfoText = styled.span`
    ${mixins.setFontVariant("caption", colorsPalettes.carbon[0])}
    margin-left: 6px;
    user-select: none;
`;

export const StyledExportInfoContainer = styled.div`
    align-items: center;
    display: flex;

    .SWReactIcons svg path:last-child {
        fill: ${colorsPalettes.carbon["0"]};
    }
`;
